import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  components: [],
  selectedComponent: null,
  surveys: [], // Add surveys array to initial state
};

export const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    addComponent: (state, action) => {
      state.components.push({
        id: `q-${Date.now()}`,
        ...action.payload,
      });
    },
    setSurveys: (state, action) => {
      state.surveys = action.payload;
    },
    deleteSurvey: (state, action) => {
      state.surveys = state.surveys.filter(survey => survey.id !== action.payload);
    },
  },
});

export const { addComponent, setSurveys, deleteSurvey } = surveySlice.actions;
export default surveySlice.reducer;